import React from "react";

import FIlterSelect from "../filter-select";
import Input from "../input";
import { I_Customer } from "../../pages/customers/types";
import { capitalizeFirstLetter, formatDate } from "../../utilz/function";
import { Controller } from "react-hook-form";

interface OrderDetailsProps {
  control: any;
  errors: any;
  customer?: I_Customer | null;
}

const OrderDetails: React.FC<OrderDetailsProps> = ({ control, customer }) => {
  return (
    <div className="flex flex-col gap-5">

      <div className="items-center gap-4">
        <Controller
          name="orderDate"
          control={control}
          
          rules={{
            required: "Date is required",
          }}
          render={({ field, fieldState }) => (
            <Input
              value={field.value}
              type="date"
              className="w-full"
              label="Order Date"
              placeholder="Enter Date"
              error={fieldState?.error?.message}
              onChange={field.onChange}
            />
          )}
        />
      </div>
      {/* Customer field is handled in parent component */}

      <Input
        name="accountType"
        value={customer?.accountType || ""}
        className="w-full"
        label="Account Type"
        placeholder="Enter Payment Term"
      />

      <Input
        value={capitalizeFirstLetter(customer?.creditStatus?.type) || ""}
        className="w-full"
        label="Payment Term"
        placeholder="Enter Payment Term"
      />

      <Input
        value={customer?.creditStatus?.period || 0}
        className="w-full"
        label="Payment Period"
        placeholder="Enter Payment Period"
      />

      <Input
        value={customer?.creditStatus?.limit || 0}
        className="w-full"
        label="Available Credit"
        placeholder="Enter Available Credit"
      />

      <Input
        value={customer?.creditStatus?.paymentDueDate || 0}
        className="w-full"
        label="Payment Due Day"
        placeholder="Enter Payment Due Day"
      />

      <FIlterSelect
        name="paymentStatus"
        options={[
          { value: "paid", label: "Paid" },
          { value: "unpaid", label: "UnPaid" },
          { value: "pending", label: "Pending" },
        ]}
        className="w-full"
        label="Payment Status"
      />
      <FIlterSelect
        name="deliveryMethod"
        options={[
          { value: "pickup", label: "Pick up" },
          { value: "delivery", label: "Delivery" },
        ]}
        className="w-full"
        label="Delivery Method"
      />
    </div>
  );
};

export default OrderDetails;
